import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { RechnungFertigstellenOption } from "@/components/RechnungFertigstellenOption";
import { DokumentVorschauInhalt } from "@/components/DokumentVorschau";
import { FileText, Loader2 } from "lucide-react";

// „Rechnung erstellen“ (manuell, ohne Mail) mit Option „Rechnung direkt fertigstellen“ (Standard an) bzw. „nur als Entwurf“
export const RechnungErstellenDialog = ({ orderId, open, onOpenChange, busy, onConfirm, title = "Rechnung erstellen" }) => {
  const [fertig, setFertig] = useState(true);
  useEffect(() => { if (open) setFertig(true); }, [open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="rechnung-erstellen-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileText className="w-5 h-5 text-slate-600" /> {title}</DialogTitle>
          <DialogDescription>Die Rechnung wird in sevDesk mit genau den aktuellen Auftragspositionen erstellt (Briefpapier, Skonto, Prüfung der Summen).</DialogDescription>
        </DialogHeader>
        {open && orderId && <DokumentVorschauInhalt orderId={orderId} typ="rechnung" />}
        <RechnungFertigstellenOption checked={fertig} onChange={setFertig} disabled={busy} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} data-testid="rechnung-erstellen-cancel">Abbrechen</Button>
          <Button onClick={() => onConfirm(fertig)} disabled={busy} data-testid="rechnung-erstellen-confirm">
            {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Rechnung wird erstellt…</> : fertig ? "Jetzt anlegen und fertigstellen" : "Jetzt als Entwurf anlegen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
